import { render, staticRenderFns } from "./wifi.vue?vue&type=template&id=7884d168&"
import script from "./wifi.vue?vue&type=script&lang=js&"
export * from "./wifi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wifi.vue"
export default component.exports